// Должен соответствовать projectName
export const UNIQUE_CONFIG_KEY = 'favorites-frontend';
export const RECS_IN_FAVORITES_FEATURE_FLAG = 'favorite-frontend.aud_mobile_cd-287413_recs_in_favorites.enable';
